import { api1C } from './api';

export const updateCustomer = (data, params) => api1C.post('customers', data, { params });
